import { graphql } from 'react-relay';

export default graphql`
  query statusQuery(
    $trackingKey: String!
    $postalCode: String
    $companySecretId: String
  ) {
    packageTracker(
      trackingKey: $trackingKey
      postalCode: $postalCode
      companySecretId: $companySecretId
    ) {
      eta
      packageInfo {
        packageId
        trackingKey
        companyName
        companyHash
      }
      redispatchInfo {
        trackingCode
        maxPickupTime
      }
      currentStatus {
        error
        inProgress
        destination
        type
      }
      shipperStatus {
        code
        label
        description
        actionRequired {
          reasonLabel
          reasonDescription
        }
      }
      destinationInfo {
        firstLine
      }
      canAuthenticate
    }
  }
`;
